import React from "react";
import { Typography, Row, Col } from "antd";
import styled, { createGlobalStyle } from "styled-components";
import image1 from "../../../src/Assests/product2/Ecosecure (1).svg"
import image2 from "../../../src/Assests/product2/TrackRight AI.svg"
import image3 from "../../../src/Assests/product2/TrackRight Basic.svg"
import image4 from "../../../src/Assests/product2/Trackright AI Cargo.png"
import image5 from "../../../src/Assests/product2/Trackright plus.svg"




const { Title, Paragraph, Text } = Typography;


const COLORS = {
  bg: "#0B3B1E",
  bgDeep: "#082C16",
  line: "rgba(255,255,255,0.35)",
  dot: "#FFFFFF",
  dotRing: "rgba(255,255,255,0.15)",
  gold: "#C9A24B",
  text: "#FFFFFF",
  textMuted: "rgba(255,255,255,0.72)",
};

const SECTION_HEIGHT = 600; // px — vertical rhythm between products


const PRODUCTS = [
  {
    key: "basic",
    name: "TrackRight Basic",
    description:
      "TrackRight Basic is an intelligent GPS tracking and fleet management solution designed to help businesses protect assets, improve operational efficiency, and make data-driven decisions. With real-time tracking, automated reporting, driver behaviour monitoring, trip history, and instant notifications, you gain the visibility and insights needed to run safer, smarter, and more efficient operations — all from one powerful platform.",
    image:  image3,
  },
  {
    key: "ai",
    name: "TrackRight AI",
    description:
      "TrackRight AI is an intelligent IoT AI-driven logistics system focused on delivery management, trip analysis, route optimization, real-time trip monitoring, and carbon footprint visibility. It's built to improve efficiency in daily delivery operations and embrace sustainability.",
    image: image2,
  },
  {
    key: "plus",
    name: "TrackRight Plus",
    description:
      "TrackRight AI Plus is an AI-powered logistics platform designed to optimize supply chain operations, specifically focusing on first-mile, last-mile, and e-commerce deliveries. The software utilizes artificial intelligence to automate routing and real-time tracking, which has proven to increase business profitability by up to 17% while reducing fuel consumption by 20%.",
    image: image1,
  },
  {
    key: "cargo",
    name: "TrackRight AI Cargo",
    description:
      "TrackRight AI Cargo is an IoT driven AI-powered logistics software designed to optimize first-mile & last-mile for shipping containers/ containerized cargo embracing sustainably.",
    image: image4,
  },
  {
    key: "eco",
    name: "EcoSecure",
    description:
      "EcoSecure is a smart vehicle and fleet security tracking solution designed to help businesses monitor, protect, and optimize their vehicles in real time — while also promoting safer driving and environmental responsibility.",
    image:image5,
  },
];

/* ------------------------------------------------------------------ */
/*  Styled components                                                  */
/* ------------------------------------------------------------------ */
const GlobalFontStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap');
`;

const Wrapper = styled.section`
  position: relative;
  width: 100%;
  background: radial-gradient(circle at 15% 0%, ${COLORS.bg} 0%, ${COLORS.bgDeep} 65%);
  padding: 96px 0 40px;
  font-family: "Manrope", -apple-system, BlinkMacSystemFont, sans-serif;
  overflow: hidden;
`;

const Eyebrow = styled(Text)`
  display: inline-block;
  color: #fff;
  letter-spacing: 0.28em;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 8px;
  padding-left: 40px;  
  padding-bottom: 8px;    
`;

const HeaderTitle = styled(Title)`
  &.ant-typography {
    color: ${COLORS.text} !important;
    font-weight: 800 !important;
    margin: 0 0 64px !important;
    font-size: 34px !important;
  }
`;

const Rail = styled.div`
  position: relative;
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 40px;
`;

/* the vertical connecting spine, centered under the dots */
const Spine = styled.div`
  position: absolute;
  top: 14px;
  bottom: 14px;
  left: 52px;
  width: 2px;
  background: linear-gradient(
    to bottom,
    transparent 0%,
    ${COLORS.line} 6%,
    ${COLORS.line} 94%,
    transparent 100%
  );

  @media (max-width: 767px) {
    left: 12px;
  }
`;

const ProductBlock = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  min-height: ${(p) => (p.$isLast ? "auto" : `${SECTION_HEIGHT}px`)};
  padding-top: 4px;

  @media (max-width: 767px) {
    min-height: auto;
    margin-bottom: 64px;
  }
`;

const MarkerCol = styled.div`
  position: relative;
  width: 104px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;

  @media (max-width: 767px) {
    width: 24px;
  }
`;

const Dot = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: ${COLORS.dot};
  box-shadow: 0 0 0 8px ${COLORS.dotRing};
  z-index: 2;
`;

const ContentCol = styled.div`
  flex: 1;
  padding-right: 48px;
  max-width: 560px;

  @media (max-width: 991px) {
    max-width: 100%;
    padding-right: 0;
  }
`;

const ProductTitle = styled(Title)`
  &.ant-typography {
    color: ${COLORS.text} !important;
    font-weight: 800 !important;
    font-size: 26px !important;
    margin: -2px 0 14px !important;
  }
`;

const ProductDescription = styled(Paragraph)`
  &.ant-typography {
    color: ${COLORS.textMuted} !important;
    font-size: 14px !important;
    line-height: 1.7 !important;
    max-width: 460px;
    margin-bottom: 0 !important;
  }
`;

const ImageCol = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;

  @media (max-width: 991px) {
    margin-top: 24px;
  }
`;

const ImageFrame = styled.div`
  position: relative;
  width: 100%;
  max-width: 420px;
  aspect-ratio: 6 / 5;
  border-radius: 18px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

/* ------------------------------------------------------------------ */
/*  Component                                                          */
/* ------------------------------------------------------------------ */
const ProductSection = () => {
  return (
    <Wrapper>
      <GlobalFontStyle />
      <Rail>
        <Eyebrow>Our Products</Eyebrow>

        <div style={{ position: "relative" }}>
          <Spine />

          {PRODUCTS.map((product, index) => (
            <ProductBlock key={product.key} $isLast={index === PRODUCTS.length - 1}>
              <MarkerCol>
                <Dot />
              </MarkerCol>

              <Row
                style={{ flex: 1 }}
                gutter={[32, 24]}
                align="top"
                wrap
              >
                <Col xs={24} md={13}>
                  <ContentCol>
                    <ProductTitle level={3}>{product.name}</ProductTitle>
                    <ProductDescription>{product.description}</ProductDescription>
                  </ContentCol>
                </Col>
                <Col xs={24} md={11}>
                  <ImageCol>
                    <ImageFrame>
                      <img src={product.image} alt={product.name} />
                    </ImageFrame>
                  </ImageCol>
                </Col>
              </Row>
            </ProductBlock>
          ))}
        </div>
      </Rail>
    </Wrapper>
  );
};

export default ProductSection;